import React, { useState } from 'react';
import * as d3 from 'd3';
import './ArrayVisualizer.css'; // Importing custom CSS for styling

const ArrayVisualizer = () => {
  const [array, setArray] = useState([5, 10, 15, 20, 25]);
  const [inputValue, setInputValue] = useState('');
  const [indexValue, setIndexValue] = useState('');

  const handleInsertAtEnd = () => {
    setArray([...array, parseInt(inputValue)]);
    setInputValue('');
  };

  const handleInsertAtIndex = () => {
    const index = parseInt(indexValue);
    if (index >= 0 && index <= array.length) {
      const newArray = [...array];
      newArray.splice(index, 0, parseInt(inputValue));
      setArray(newArray);
    }
    setInputValue('');
    setIndexValue('');
  };

  const handleDeleteAtEnd = () => {
    setArray(array.slice(0, -1));
  };

  const handleDeleteAtIndex = () => {
    const index = parseInt(indexValue);
    if (index >= 0 && index < array.length) {
      const newArray = [...array];
      newArray.splice(index, 1);
      setArray(newArray);
    }
    setIndexValue('');
  };

  const handleSearch = () => {
    const value = parseInt(inputValue);
    const index = array.indexOf(value);
    if (index !== -1) {
      alert(`Value ${value} found at index ${index}`);
    } else {
      alert(`Value ${value} not found`);
    }
    setInputValue('');
  };

  const handleUpdate = () => {
    const index = parseInt(indexValue);
    if (index >= 0 && index < array.length) {
      const newArray = [...array];
      newArray[index] = parseInt(inputValue);
      setArray(newArray);
    }
    setInputValue('');
    setIndexValue('');
  };

  const drawArray = () => {
    const svg = d3.select('#array-container').attr('width', 600).attr('height', 100);
    svg.selectAll('*').remove(); // Clear previous elements

    svg
      .selectAll('rect')
      .data(array)
      .enter()
      .append('rect')
      .attr('x', (d, i) => i * 70 + 20)
      .attr('y', 20)
      .attr('width', 60)
      .attr('height', 60)
      .attr('fill', 'skyblue')
      .attr('stroke', 'black')
      .attr('stroke-width', 2)
      .style('border-radius', '10px');

    svg
      .selectAll('text')
      .data(array)
      .enter()
      .append('text')
      .attr('x', (d, i) => i * 70 + 50)
      .attr('y', 55)
      .attr('text-anchor', 'middle')
      .attr('fill', 'black')
      .attr('font-size', '16px')
      .text(d => d);
  };

  React.useEffect(() => {
    drawArray();
  }, [array]);

  return (
    <div className="container">
      <div className="visualizer-section">
        <h2>Array Visualizer</h2>
        <svg id="array-container"></svg>
        <div className="controls">
          <input
            type="number"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Enter value"
          />
          <input
            type="number"
            value={indexValue}
            onChange={(e) => setIndexValue(e.target.value)}
            placeholder="Enter index"
          />
          <button onClick={handleInsertAtEnd}>Insert at End</button>
          <button onClick={handleInsertAtIndex}>Insert at Index</button>
          <button onClick={handleDeleteAtEnd}>Delete at End</button>
          <button onClick={handleDeleteAtIndex}>Delete at Index</button>
          <button onClick={handleSearch}>Search</button>
          <button onClick={handleUpdate}>Update</button>
        </div>
      </div>
    </div>
  );
};

export default ArrayVisualizer;
